/*
 * @Author: liushengjiang 1947448287@qq.com
 * @Date: 2021-12-28 15:26:11
 * @LastEditors: liushengjiang 1947448287@qq.com
 * @LastEditTime: 2023-12-12 14:55:28
 * @FilePath: \petro-web-chemicals-buyerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\request\flutterBrid.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const getTopBar = (backFun) => {
  try {
    // eslint-disable-next-line no-undef
    BarTop.postMessage('height')
  } catch (e) {
    console.log('调用异常')
  }
  window['getTopBar'] = (resultMessage) => {
    backFun(resultMessage)
  }
}
//买家还是卖家登陆
const loginSources = () => {
  try {  
    // eslint-disable-next-line no-undef
    loginSource.postMessage('2')
  } catch (e) {
    console.log('loginSource异常')
  }
}
//获取设备信息
const getVersion = (backFun) => {
  try {  
    // eslint-disable-next-line no-undef
   appPackageInfo.postMessage('')
  } catch (e) {
    console.log('getVersion调用异常')
    backFun('22222')
  }
  window['onGetVersion'] = (result) => {
    backFun(result)
  }
}
const getRenew = (info,backFun) => {
  try {
    console.log(info)
    // eslint-disable-next-line no-undef
    downFile.postMessage(info)
  } catch (e) {
    console.log('getRenew调用异常')
  }
  window['getRenew'] = (result) => {
    backFun(result)
  }
}
const getloadFile = (info,backFun) => {
  try {
    console.log(info)
    // eslint-disable-next-line no-undef
    downloadFile.postMessage(info)
  } catch (e) {
    console.log('getloadFile调用异常')
  }
  window['onDownloadFile'] = (result) => {
    backFun(result)
  }
}
//文件上传
const getPickFile = (info,backFun) => {
  try {
    console.log(info)
     // eslint-disable-next-line no-undef
    pickFile.postMessage(info)
  } catch (e) {
    console.log('pickFile调用异常')
  }
  window['onPickFile'] = (result) => {
    backFun(result)
  }
}
// 扫码
const getScan = (backFun) => {
  try {
    // eslint-disable-next-line no-undef
    barcodeScan.postMessage('JS调用了Flutter')
  } catch (e) {
    console.log('调用异常')
  }
  window['getScan'] = (resultMessage) => {
    backFun(resultMessage)
  }
  
}
const getcamera = (type, backFun) => {
  try {
    // eslint-disable-next-line no-undef
    cameraOption.postMessage(type) // '1' 拍照上传； '2'从相册中取
  } catch (e) {
    console.log('cameraOption调用异常')
  }
  window['getImageInfo'] = (result) => {
    backFun(result)
  }
}

export { getTopBar, getScan, getcamera,loginSources,getRenew,getloadFile,getPickFile,getVersion }
